var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVersion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 37.367,
    viewBox: "0 0 32 37.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "version_1_",
    "data-name": "version (1)",
    transform: "translate(-96.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M183.4,13.229h-5.367A3.932,3.932,0,0,1,174.1,9.3V3.931A3.927,3.927,0,0,0,170.173,0h-5.542A3.927,3.927,0,0,0,160.7,3.931V28.069A3.927,3.927,0,0,0,164.631,32H183.4a3.932,3.932,0,0,0,3.931-3.931v-10.9A3.934,3.934,0,0,0,183.4,13.229Zm-4.323,4.808-5.367,8.046a1.263,1.263,0,0,1-2.087,0l-2.679-4.023a1.252,1.252,0,0,1,2.087-1.385l1.644,2.462L177,16.651a1.249,1.249,0,1,1,2.078,1.385Z",
    transform: "translate(-58.933)",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M99.263,88.652V66.1A3.935,3.935,0,0,0,96.4,69.881V94.019a3.932,3.932,0,0,0,3.931,3.931H119.1a3.936,3.936,0,0,0,3.781-2.863H105.689a6.431,6.431,0,0,1-6.427-6.435Z",
    transform: "translate(0 -60.583)",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M341.035,15.805a1.432,1.432,0,0,0,1.427,1.427h5.367a6.461,6.461,0,0,1,3.33.926A7.726,7.726,0,0,0,349.5,15.7l-6.936-6.936A7.726,7.726,0,0,0,340.1,7.1a6.36,6.36,0,0,1,.926,3.33l.008,5.375Z",
    transform: "translate(-223.36 -6.507)",
    fill: "#4397d2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersion);
export default __webpack_public_path__ + "static/media/version.344c050fc700a262a83014092a36adc2.svg";
export { ForwardRef as ReactComponent };